module.exports = __webpack_public_path__ + "static/media/search.5afcb2fe.svg";